import type { IGetLocalization } from 'src/interfaces';

export const getSectionName = (section: string, getLocalization: IGetLocalization) => {
  return section?.match(/^\d/) ? `${getLocalization('Section')} ${section}` : section;
};
